import React from "react";
import {
  AbsoluteFill,
  spring,
  useCurrentFrame,
  useVideoConfig,
  Audio,
  Img,
  staticFile,
} from "remotion";

export const KyuStoreSatireAntiRibet: React.FC = () => {
  const frame = useCurrentFrame();
  const { fps } = useVideoConfig();

  // Durasi total 67.5 detik @ 30fps = 2028 frame
  // 13 FAST-PACED SCENE CUTS (Transisi tiap 4-6 detik):
  // S1: 0 - 90f    (0.0 - 3.0s)  -> Hook 1: "MAU BELI DIAMOND 20RB..."
  // S2: 90 - 180f  (3.0 - 6.0s)  -> Hook 2: "...KENAPA MINTA NO WA & EMAIL?!"
  // S3: 180 - 330f (6.0 - 11.0s) -> Satire: Mau Jajan Game apa Sensus Penduduk?
  // S4: 330 - 480f (11.0 - 16.0s)-> Satire: Form WhatsApp & Nomor Terekspos
  // S5: 480 - 630f (16.0 - 21.0s)-> Satire: Chat Spam WA Subuh 03:41 AM
  // S6: 630 - 780f (21.0 - 26.0s)-> Satire: Email Numpuk & Notifikasi Sampah
  // S7: 780 - 960f (26.0 - 32.0s)-> Satire: Panik Lobby Mabar + Birokrasi OTP
  // S8: 960 - 1100f(32.0 - 36.6s)-> Hard Reset: "SKIP BIROKRASI. PINDAH KE KYU STORE."
  // S9: 1100 - 1260f(36.6 - 42.0s)-> Manifesto: NO WA & NO EMAIL (Tidak Butuh!)
  // S10: 1260 - 1440f(42.0 - 48.0s)-> Input Mockup: 1 Baris Cuma ID Game
  // S11: 1440 - 1620f(48.0 - 54.0s)-> Auto-Detect Nickname: Zura_Official_ML
  // S12: 1620 - 1800f(54.0 - 60.0s)-> Scan QRIS & Speed: 1.2 Detik Masuk
  // S13: 1800 - 2028f(60.0 - 67.5s)-> Outro Poster: KYUSTORE.COM Anti-Ribet

  // Helper spring generator per scene start frame
  const getSceneSpring = (startFrame: number) =>
    spring({ frame: Math.max(0, frame - startFrame), fps, config: { damping: 16, stiffness: 160 } });

  // Floating micro-drift
  const floatY = Math.sin(frame / 18) * 6;

  // Active Scene Boolean Flags
  const isS1 = frame < 90;
  const isS2 = frame >= 90 && frame < 180;
  const isS3 = frame >= 180 && frame < 330;
  const isS4 = frame >= 330 && frame < 480;
  const isS5 = frame >= 480 && frame < 630;
  const isS6 = frame >= 630 && frame < 780;
  const isS7 = frame >= 780 && frame < 960;
  const isS8 = frame >= 960 && frame < 1100;
  const isS9 = frame >= 1100 && frame < 1260;
  const isS10 = frame >= 1260 && frame < 1440;
  const isS11 = frame >= 1440 && frame < 1620;
  const isS12 = frame >= 1620 && frame < 1800;
  const isS13 = frame >= 1800;

  // Dynamic Subtitles
  let currentSubtitle = "Gue heran deh... Mau beli diamond dua puluh ribu aja...";
  if (frame >= 90 && frame < 180) {
    currentSubtitle = "Kenapa toko sebelah harus minta nomor WhatsApp sama email sih?!";
  } else if (frame >= 180 && frame < 330) {
    currentSubtitle = "Lu mau jajan game apa mau daftar sensus penduduk?";
  } else if (frame >= 330 && frame < 480) {
    currentSubtitle = "Udah minta nomor WA, ujung-ujungnya nomor kita dispam promo tiap subuh.";
  } else if (frame >= 480 && frame < 630) {
    currentSubtitle = "Jam 3 pagi dapet chat promo gak jelas... ngeganggu tidur banget.";
  } else if (frame >= 630 && frame < 780) {
    currentSubtitle = "Email juga isinya notifikasi numpuk. Padahal niat kita simpel: mau beli pass, kelar.";
  } else if (frame >= 780 && frame < 960) {
    currentSubtitle = "Lagi di lobby mabar disuruh ketik email berkali-kali... masa main game pake birokrasi?";
  } else if (frame >= 960 && frame < 1100) {
    currentSubtitle = "Makanya sekarang gue pindah total ke Kyu Store. Di sini beneran gak ada drama!";
  } else if (frame >= 1100 && frame < 1260) {
    currentSubtitle = "Gak ada minta-minta nomor WhatsApp. Gak ada palak email!";
  } else if (frame >= 1260 && frame < 1440) {
    currentSubtitle = "Lu cuma buka web, masukin ID game lu—simpel gak pake basa-basi.";
  } else if (frame >= 1440 && frame < 1620) {
    currentSubtitle = "Detik itu juga nickname game lu langsung kedeteksi secara otomatis!";
  } else if (frame >= 1620 && frame < 1800) {
    currentSubtitle = "Pilih nominal, scan QRIS, beres. Satu detik langsung mendarat di akun game lu!";
  } else if (frame >= 1800) {
    currentSubtitle = "Top up anti-ribet? Langsung buka kyustore.com sekarang!";
  }

  const isKyuScene = frame >= 960;

  return (
    <AbsoluteFill
      style={{
        backgroundColor: "#111815", // Solid Deep Pine Matte (Zero Grid)
        color: "#f4f6f4",
        fontFamily: "'Space Grotesk', 'Inter', -apple-system, sans-serif",
        overflow: "hidden",
      }}
    >
      {/* Voiceover Mastered Audio */}
      <Audio src={staticFile("audio/satire_mastered.mp3")} volume={1.0} />

      {/* TOP BRAND HEADER (Y: 230px) */}
      <div
        style={{
          position: "absolute",
          top: 230,
          left: 90,
          right: 90,
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          borderBottom: "1.5px solid rgba(244, 246, 244, 0.15)",
          paddingBottom: 16,
          zIndex: 60,
        }}
      >
        <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
          <div
            style={{
              width: 12,
              height: 12,
              borderRadius: "50%",
              backgroundColor: isKyuScene ? "#e8f36e" : "#e04336",
            }}
          />
          <span
            style={{
              fontSize: 20,
              fontWeight: 800,
              letterSpacing: "0.15em",
              color: isKyuScene ? "#e8f36e" : "#ffffff",
              textTransform: "uppercase",
            }}
          >
            {isKyuScene ? "KYU STORE // ANTI-RIBET" : "BIROKRASI TOKO SEBELAH"}
          </span>
        </div>
        <div
          style={{
            fontSize: 15,
            fontFamily: "monospace",
            letterSpacing: "0.08em",
            color: "rgba(244, 246, 244, 0.6)",
          }}
        >
          {isKyuScene ? "ZERO METADATA ✓" : "ISSUE: DATA HARVEST"}
        </div>
      </div>

      {/* ======================================================== */}
      {/* CENTERED STAGE (Y: 330px - 1420px) — KONTEN UTAMA MULTI-FRAME */}
      {/* ======================================================== */}
      <div
        style={{
          position: "absolute",
          top: 320,
          left: 90,
          right: 90,
          height: 1100,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          zIndex: 40,
        }}
      >
        {/* FRAME 1: HOOK BAGIAN 1 (0 - 3s) */}
        {isS1 && (
          <div
            style={{
              width: "100%",
              backgroundColor: "#18231f",
              border: "2px solid #283a33",
              borderRadius: 24,
              padding: "60px 48px",
              transform: `scale(${getSceneSpring(0)}) translateY(${floatY}px)`,
              display: "flex",
              flexDirection: "column",
              gap: 20,
            }}
          >
            <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
              <span
                style={{
                  backgroundColor: "#283a33",
                  color: "#cbd5cf",
                  fontSize: 18,
                  fontWeight: 800,
                  padding: "6px 16px",
                  borderRadius: 4,
                  letterSpacing: "0.08em",
                  textTransform: "uppercase",
                }}
              >
                REALITA GAMER
              </span>
              <span style={{ fontSize: 16, color: "#8a9e94", fontFamily: "monospace" }}>01 // 13</span>
            </div>
            <h1
              style={{
                fontSize: 72,
                fontWeight: 900,
                lineHeight: 1.08,
                letterSpacing: "-0.03em",
                margin: 0,
                textTransform: "uppercase",
                color: "#ffffff",
              }}
            >
              MAU BELI
              <br />
              <span style={{ color: "#e8f36e", fontSize: 84 }}>DIAMOND 20RB...</span>
            </h1>
            <div style={{ fontSize: 24, color: "#8a9e94" }}>Niat kita simpel: cuma mau beli pass, beres.</div>
          </div>
        )}

        {/* FRAME 2: HOOK BAGIAN 2 (3 - 6s) */}
        {isS2 && (
          <div
            style={{
              width: "100%",
              backgroundColor: "#18231f",
              border: "2px solid #e04336",
              borderRadius: 24,
              padding: "60px 48px",
              transform: `scale(${getSceneSpring(90)})`,
              display: "flex",
              flexDirection: "column",
              gap: 22,
            }}
          >
            <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
              <span
                style={{
                  backgroundColor: "#e04336",
                  color: "#ffffff",
                  fontSize: 18,
                  fontWeight: 800,
                  padding: "6px 16px",
                  borderRadius: 4,
                  letterSpacing: "0.08em",
                  textTransform: "uppercase",
                }}
              >
                ⚠️ LOGIKA ANEH
              </span>
              <span style={{ fontSize: 16, color: "#8a9e94", fontFamily: "monospace" }}>02 // 13</span>
            </div>
            <h1
              style={{
                fontSize: 66,
                fontWeight: 900,
                lineHeight: 1.1,
                letterSpacing: "-0.03em",
                margin: 0,
                textTransform: "uppercase",
                color: "#ffffff",
              }}
            >
              KENAPA MINTA
              <br />
              <span
                style={{
                  backgroundColor: "#f4f6f4",
                  color: "#111815",
                  padding: "2px 14px",
                  borderRadius: 6,
                }}
              >
                NO. WA & EMAIL?!
              </span>
            </h1>
            <div style={{ height: 2, backgroundColor: "#283a33", width: "100%" }} />
            <div style={{ fontSize: 24, color: "#e04336", fontWeight: 700 }}>
              Cuma transaksi receh tapi minta data pribadi lengkap!
            </div>
          </div>
        )}

        {/* FRAME 3: SENSUS PENDUDUK SATIRE (6 - 11s) */}
        {isS3 && (
          <div
            style={{
              width: "100%",
              backgroundColor: "#18231f",
              border: "2px solid #283a33",
              borderRadius: 24,
              padding: "50px 44px",
              transform: `scale(${getSceneSpring(180)})`,
              textAlign: "center",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              gap: 20,
            }}
          >
            <div
              style={{
                fontSize: 54,
                backgroundColor: "#283a33",
                width: 90,
                height: 90,
                borderRadius: "50%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              📋
            </div>
            <h2 style={{ fontSize: 52, fontWeight: 900, margin: 0, textTransform: "uppercase" }}>
              MAU JAJAN GAME
              <br />
              <span style={{ color: "#e04336" }}>APA SENSUS PENDUDUK?</span>
            </h2>
            <div
              style={{
                backgroundColor: "#111815",
                padding: "16px 28px",
                borderRadius: 12,
                border: "1px dashed #e04336",
                fontSize: 22,
                color: "#cbd5cf",
                marginTop: 10,
              }}
            >
              Format data toko lain udah kayak mau pengajuan KPR rumah subsidi.
            </div>
          </div>
        )}

        {/* FRAME 4: WHATSAPP EXPOSURE (11 - 16s) */}
        {isS4 && (
          <div
            style={{
              width: "100%",
              backgroundColor: "#18231f",
              border: "2px solid #e04336",
              borderRadius: 24,
              padding: "48px 44px",
              transform: `scale(${getSceneSpring(330)})`,
            }}
          >
            <div style={{ fontSize: 20, fontWeight: 800, color: "#e04336", marginBottom: 12 }}>
              TAHAP 1: INPUT NO WHATSAPP
            </div>
            <div
              style={{
                backgroundColor: "#111815",
                border: "2px solid #e04336",
                borderRadius: 12,
                padding: "20px 24px",
                fontSize: 26,
                fontFamily: "monospace",
                color: "#ffffff",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <span>0812-9988-XXXX</span>
              <span style={{ fontSize: 16, color: "#e04336", fontWeight: 700 }}>[DATA BOCOR]</span>
            </div>
            <div style={{ marginTop: 24, fontSize: 22, color: "#cbd5cf", lineHeight: 1.4 }}>
              Udah setor nomor WA aktif... tebak apa yang terjadi beberapa jam kemudian?
            </div>
          </div>
        )}

        {/* FRAME 5: SPAM WA SUBUH (16 - 21s) */}
        {isS5 && (
          <div
            style={{
              width: "100%",
              backgroundColor: "#18231f",
              border: "2px solid #283a33",
              borderRadius: 24,
              padding: "44px 40px",
              transform: `scale(${getSceneSpring(480)}) translateY(${floatY}px)`,
              display: "flex",
              flexDirection: "column",
              gap: 20,
            }}
          >
            <div style={{ fontSize: 20, fontWeight: 800, color: "#25D366" }}>
              NOTIFIKASI WHATSAPP // JAM 03:41 AM
            </div>
            <div
              style={{
                backgroundColor: "#13211b",
                border: "2px solid #25D366",
                borderRadius: 16,
                padding: "24px 24px",
                display: "flex",
                alignItems: "center",
                gap: 20,
              }}
            >
              <div
                style={{
                  fontSize: 28,
                  backgroundColor: "#25D366",
                  color: "#111815",
                  width: 56,
                  height: 56,
                  borderRadius: "50%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  fontWeight: 900,
                }}
              >
                WA
              </div>
              <div style={{ flex: 1 }}>
                <div style={{ display: "flex", justifyContent: "space-between", fontSize: 16 }}>
                  <span style={{ fontWeight: 800, color: "#25D366" }}>Toko Sebelah CS (Subuh)</span>
                  <span style={{ color: "#8a9e94" }}>03:41</span>
                </div>
                <div style={{ fontSize: 18, color: "#ffffff", marginTop: 4, fontWeight: 600 }}>
                  "P... Kak bangun kak, ada promo diamond murah nih order sekarang..."
                </div>
              </div>
            </div>
            <div style={{ fontSize: 22, color: "#e04336", fontWeight: 700 }}>
              Ujung-ujungnya nomor pribadi lu dispam promo tiap subuh!
            </div>
          </div>
        )}

        {/* FRAME 6: EMAIL OVERLOAD (21 - 26s) */}
        {isS6 && (
          <div
            style={{
              width: "100%",
              backgroundColor: "#18231f",
              border: "2px solid #283a33",
              borderRadius: 24,
              padding: "44px 40px",
              transform: `scale(${getSceneSpring(630)})`,
              display: "flex",
              flexDirection: "column",
              gap: 20,
            }}
          >
            <div style={{ fontSize: 20, fontWeight: 800, color: "#cbd5cf" }}>
              INBOX EMAIL // 99+ NOTIFIKASI SAMPAH
            </div>
            <div
              style={{
                backgroundColor: "#111815",
                border: "1.5px solid #283a33",
                borderRadius: 14,
                padding: "20px 24px",
                display: "flex",
                flexDirection: "column",
                gap: 12,
              }}
            >
              <div style={{ fontSize: 18, color: "#ffffff", fontWeight: 700 }}>
                📩 [PROMO] Flash Sale Topup Game...
              </div>
              <div style={{ fontSize: 18, color: "#ffffff", fontWeight: 700 }}>
                📩 [NEWSLETTER] Jangan lewatkan event...
              </div>
              <div style={{ fontSize: 18, color: "#e04336", fontWeight: 700 }}>
                📩 [ALERT] Verifikasi email kamu sekarang...
              </div>
            </div>
            <div style={{ fontSize: 22, color: "#8a9e94" }}>
              Inbox email penuh sampah. Padahal kita cuma mau top up sekali, beres.
            </div>
          </div>
        )}

        {/* FRAME 7: LOBBY PANIC & OTP (26 - 32s) */}
        {isS7 && (
          <div
            style={{
              width: "100%",
              backgroundColor: "#18231f",
              border: "2px solid #e04336",
              borderRadius: 24,
              padding: "44px 40px",
              transform: `scale(${getSceneSpring(780)})`,
              display: "flex",
              flexDirection: "column",
              gap: 20,
            }}
          >
            <div style={{ fontSize: 20, fontWeight: 800, color: "#e04336" }}>
              ⚠️ PANIK DI LOBBY MABAR
            </div>
            <div style={{ fontSize: 44, fontWeight: 900, lineHeight: 1.1, color: "#ffffff" }}>
              EVENT SISA 2 MENIT,
              <br />
              <span style={{ color: "#e04336" }}>TAPI KETIK EMAIL TYPO?!</span>
            </div>
            <div
              style={{
                backgroundColor: "#111815",
                border: "1px dashed #283a33",
                borderRadius: 10,
                padding: "16px 20px",
                fontSize: 18,
                color: "#a5b4ac",
              }}
            >
              Status: Menunggu kode OTP SMS... [Antrian #47]
            </div>
            <div style={{ fontSize: 22, color: "#cbd5cf" }}>
              Masa cuma mau hiburan main game aja harus ngelewatin birokrasi rumit?
            </div>
          </div>
        )}

        {/* FRAME 8: HARD RESET / PINDAH KE KYU STORE (32 - 36s) */}
        {isS8 && (
          <div
            style={{
              width: "100%",
              backgroundColor: "#18231f",
              border: "3px solid #e8f36e",
              borderRadius: 28,
              padding: "60px 48px",
              textAlign: "center",
              transform: `scale(${getSceneSpring(960)})`,
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              gap: 24,
            }}
          >
            <span
              style={{
                backgroundColor: "#e8f36e",
                color: "#111815",
                fontSize: 20,
                fontWeight: 900,
                padding: "8px 24px",
                borderRadius: 4,
                letterSpacing: "0.08em",
                textTransform: "uppercase",
              }}
            >
              SOLUSI MUTLAK
            </span>
            <h1
              style={{
                fontSize: 68,
                fontWeight: 900,
                lineHeight: 1.05,
                margin: 0,
                textTransform: "uppercase",
              }}
            >
              SKIP BIROKRASINYA.
              <br />
              PINDAH TOTAL KE <span style={{ color: "#e8f36e" }}>KYU STORE</span>
            </h1>
            <div style={{ fontSize: 26, color: "#cbd5cf" }}>
              Standar baru top up game: 100% Zero Drama!
            </div>
          </div>
        )}

        {/* FRAME 9: MANIFESTO ANTI-RIBET (36 - 42s) */}
        {isS9 && (
          <div
            style={{
              width: "100%",
              backgroundColor: "#18231f",
              border: "2px solid #283a33",
              borderRadius: 24,
              padding: "48px 44px",
              transform: `scale(${getSceneSpring(1100)})`,
              display: "flex",
              flexDirection: "column",
              gap: 24,
            }}
          >
            <div style={{ fontSize: 22, fontWeight: 800, color: "#e8f36e", letterSpacing: "0.1em" }}>
              MANIFESTO KYU STORE:
            </div>
            <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 18 }}>
              <div
                style={{
                  backgroundColor: "#111815",
                  border: "2px solid #283a33",
                  borderRadius: 14,
                  padding: "28px 20px",
                  textAlign: "center",
                }}
              >
                <div style={{ fontSize: 18, color: "#8a9e94", marginBottom: 8 }}>MINTA NO WA?</div>
                <div style={{ fontSize: 32, fontWeight: 900, color: "#e8f36e" }}>TIDAK BUTUH</div>
              </div>
              <div
                style={{
                  backgroundColor: "#111815",
                  border: "2px solid #283a33",
                  borderRadius: 14,
                  padding: "28px 20px",
                  textAlign: "center",
                }}
              >
                <div style={{ fontSize: 18, color: "#8a9e94", marginBottom: 8 }}>MINTA EMAIL?</div>
                <div style={{ fontSize: 32, fontWeight: 900, color: "#e8f36e" }}>TIDAK BUTUH</div>
              </div>
            </div>
            <div style={{ fontSize: 24, color: "#cbd5cf", textAlign: "center" }}>
              Privasi data kamu aman. Nol jejak kontak pribadi.
            </div>
          </div>
        )}

        {/* FRAME 10: INPUT CUMA ID (42 - 48s) */}
        {isS10 && (
          <div
            style={{
              width: "100%",
              backgroundColor: "#18231f",
              border: "2px solid #e8f36e",
              borderRadius: 24,
              padding: "48px 44px",
              transform: `scale(${getSceneSpring(1260)})`,
              display: "flex",
              flexDirection: "column",
              gap: 20,
            }}
          >
            <div style={{ fontSize: 18, fontWeight: 800, color: "#a5b4ac" }}>
              SATU-SATUNYA YANG DIBUTUHKAN:
            </div>
            <div
              style={{
                backgroundColor: "#111815",
                border: "2px solid #e8f36e",
                borderRadius: 14,
                padding: "24px 28px",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <div>
                <div style={{ fontSize: 16, color: "#8a9e94" }}>INPUT ID GAME / SERVER</div>
                <div style={{ fontSize: 36, fontFamily: "monospace", fontWeight: 900, color: "#ffffff" }}>
                  84920194 (2026)
                </div>
              </div>
              <span
                style={{
                  backgroundColor: "#e8f36e",
                  color: "#111815",
                  fontSize: 16,
                  fontWeight: 900,
                  padding: "6px 16px",
                  borderRadius: 4,
                }}
              >
                CUKUP INI ✓
              </span>
            </div>
            <div style={{ fontSize: 22, color: "#cbd5cf" }}>
              Tinggal buka kyustore.com, masukin ID game lu—selesai.
            </div>
          </div>
        )}

        {/* FRAME 11: AUTO-DETECT NICKNAME (48 - 54s) */}
        {isS11 && (
          <div
            style={{
              width: "100%",
              backgroundColor: "#18231f",
              border: "2px solid #e8f36e",
              borderRadius: 24,
              padding: "50px 44px",
              transform: `scale(${getSceneSpring(1440)}) translateY(${floatY}px)`,
              display: "flex",
              flexDirection: "column",
              gap: 22,
            }}
          >
            <div style={{ fontSize: 20, fontWeight: 800, color: "#e8f36e" }}>
              ⚡ SISTEM VALIDASI REALTIME
            </div>
            <div
              style={{
                backgroundColor: "#13211b",
                border: "2px solid #283a33",
                borderRadius: 16,
                padding: "26px 30px",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <div>
                <div style={{ fontSize: 16, color: "#8a9e94" }}>NICKNAME GAME VALID:</div>
                <div style={{ fontSize: 36, fontWeight: 900, color: "#e8f36e", marginTop: 4 }}>
                  Zura_Official_ML
                </div>
              </div>
              <div
                style={{
                  backgroundColor: "#283a33",
                  color: "#ffffff",
                  fontSize: 18,
                  fontWeight: 800,
                  padding: "8px 18px",
                  borderRadius: 6,
                }}
              >
                100% COCOK
              </div>
            </div>
            <div style={{ fontSize: 22, color: "#cbd5cf" }}>
              Detik itu juga nickname akun lu langsung kedeteksi otomatis!
            </div>
          </div>
        )}

        {/* FRAME 12: SCAN QRIS & 1.2S SPEED (54 - 60s) */}
        {isS12 && (
          <div
            style={{
              width: "100%",
              backgroundColor: "#18231f",
              border: "2px solid #e8f36e",
              borderRadius: 24,
              padding: "44px 40px",
              transform: `scale(${getSceneSpring(1620)})`,
              textAlign: "center",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              gap: 20,
            }}
          >
            <div
              style={{
                backgroundColor: "#e8f36e",
                color: "#111815",
                fontSize: 18,
                fontWeight: 900,
                padding: "6px 20px",
                borderRadius: 4,
                letterSpacing: "0.08em",
              }}
            >
              CHECKOUT HITUNGAN DETIK
            </div>
            <div style={{ fontSize: 44, fontWeight: 900, margin: 0, color: "#ffffff" }}>
              PILIH NOMINAL, SCAN QRIS, BERES!
            </div>
            <div
              style={{
                backgroundColor: "#ffffff",
                padding: 16,
                borderRadius: 12,
              }}
            >
              <div style={{ color: "#111815", fontSize: 16, fontWeight: 900, marginBottom: 8 }}>
                QRIS RESMI OTOMATIS
              </div>
              <div
                style={{
                  width: 160,
                  height: 160,
                  backgroundColor: "#111815",
                  borderRadius: 6,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  color: "#ffffff",
                  fontFamily: "monospace",
                  fontSize: 14,
                }}
              >
                [QRIS AUTO]
              </div>
            </div>
            <div
              style={{
                backgroundColor: "#111815",
                border: "1.5px solid #283a33",
                borderRadius: 10,
                padding: "14px 28px",
                fontSize: 22,
                fontWeight: 900,
                color: "#e8f36e",
              }}
            >
              ⚡ 1.2 DETIK LANGSUNG MENDARAT DI AKUN
            </div>
          </div>
        )}

        {/* FRAME 13: OUTRO BRAND POSTER (60 - 67.5s) */}
        {isS13 && (
          <div
            style={{
              width: "100%",
              backgroundColor: "#18231f",
              border: "2px solid #e8f36e",
              borderRadius: 28,
              padding: "54px 40px",
              textAlign: "center",
              transform: `scale(${getSceneSpring(1800)})`,
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              gap: 16,
            }}
          >
            <Img
              src={staticFile("kyu-store-logo.png")}
              style={{ width: 84, height: 84, borderRadius: 16 }}
            />
            <div
              style={{
                fontSize: 20,
                fontWeight: 800,
                color: "#e8f36e",
                letterSpacing: "0.2em",
                textTransform: "uppercase",
              }}
            >
              TOP UP GAME ANTI-RIBET
            </div>
            <h1
              style={{
                fontSize: 72,
                fontWeight: 900,
                letterSpacing: "-0.03em",
                margin: 0,
                color: "#ffffff",
              }}
            >
              KYU STORE
            </h1>
            <div
              style={{
                backgroundColor: "#e8f36e",
                color: "#111815",
                fontSize: 32,
                fontWeight: 900,
                padding: "14px 44px",
                borderRadius: 6,
                letterSpacing: "0.05em",
                marginTop: 8,
              }}
            >
              KYUSTORE.COM
            </div>
            <div
              style={{
                marginTop: 18,
                fontSize: 18,
                color: "#cbd5cf",
                display: "flex",
                gap: 18,
              }}
            >
              <span>✓ CUMA BUTUH ID</span>
              <span>✓ AUTO-NICK</span>
              <span>✓ SCAN QRIS</span>
            </div>
          </div>
        )}
      </div>

      {/* ======================================================== */}
      {/* BOTTOM SAFE ZONE SUBTITLE BAND (Anchored: Y = 1450 - 1520px) */}
      {/* ======================================================== */}
      <div
        style={{
          position: "absolute",
          top: 1450,
          left: 90,
          right: 90,
          height: 72,
          backgroundColor: "#18231f",
          border: "1.5px solid #283a33",
          borderRadius: 10,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          padding: "0 28px",
          zIndex: 80,
        }}
      >
        <span
          style={{
            fontSize: 22,
            fontWeight: 700,
            color: "#f4f6f4",
            textAlign: "center",
            lineHeight: 1.25,
          }}
        >
          {currentSubtitle}
        </span>
      </div>
    </AbsoluteFill>
  );
};
